<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>
  <div class="modal-body body-modal">
    <form [formGroup]="organzationmemberForm">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <span
              [ngClass]="
                organzationmemberForm.controls['organizationName'].value
                  ? 'justify-content-between'
                  : 'justify-content-end'
              "
              class="d-flex align-items-center"
            >
              <label
                *ngIf="organzationmemberForm.controls['organizationName']?.value"
                class="sub-header-drpdown pb-2"
                >{{ placeHolder }}</label
              >
              <span class="pb-2" *ngIf="activatedRoute == adminOrganizationRoute">
                <a
                  class="add-link"
                  target="_blank"
                  [queryParams]="userParams"
                  routerLink="/my-organization/AdminManageUsers"
                  ><span class="redirectLinkText"> Add new user</span></a
                >
                <a
                  class="setLinkIconPosition"
                  target="_blank"
                  replaceUrl="true"
                  routerLink="/my-organization/AdminManageUsers"
                >
                  <img src="./assets/icons/redirect-icon.svg" width="17" height="15" />
                </a>
                <span (click)="refreshUserList()" class="setLinkIconPosition refresh-cert"
                  ><img src="./assets/icons/refresh-circle.svg" width="16" height="15"
                /></span>
              </span>
            </span>
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              [readonly]="disableDropdown"
              [items]="organizationlist"
              #select
              [searchable]="false"
              bindLabel="name"
              formControlName="organizationName"
              [searchFn]="commonInputSearch"
              [placeholder]="placeHolder"
              (change)="selectedValue($event)"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="select.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (organzationmemberForm.controls['organizationName']?.touched &&
                  organzationmemberForm.controls['organizationName']?.invalid) ||
                organzationmemberForm.controls['organizationName'].value?.name === 'Organization' ||
                organzationmemberForm.controls['organizationName'].value?.name === '' ||
                (submitted && !organzationmemberForm.controls['organizationName'].value?.name)
              "
              class="input-error"
            >
              {{ ValidationMessageForOrganizationAndUser }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div>
            <label
              *ngIf="organzationmemberForm.controls['roleName']?.value"
              class="sub-header-drpdown pb-2"
              >Role *</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              [items]="roleListNew"
              #role
              formControlName="roleName"
              [searchable]="false"
              bindLabel="name"
              [searchFn]="commonInputSearch"
              placeholder="Role *"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="role.filter($any($event.target).value)"
                    placeholder="Search..."
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item " let-search="searchTerm ">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (organzationmemberForm.controls['roleName']?.touched &&
                  organzationmemberForm.controls['roleName']?.invalid) ||
                organzationmemberForm.controls['roleName'].value?.name ===
                  '-- Select Organization -- ' ||
                (submitted && !organzationmemberForm.controls['roleName'].value?.name)
              "
              class="input-error"
            >
              Role is required.
            </div>
          </div>
        </div>
      </div>
      <div class="row pt-3" *ngIf="isHideField">
        <div>
          <div class="form-group checkbox-text checkBoxAlienMent">
            <input
              class="chkOverview"
              type="checkbox"
              [(ngModel)]="selectCheckBox"
              [ngModelOptions]="{ standalone: true }"
            />
            <span class="isActive">Active</span>
          </div>
        </div>
      </div>
    </form>
    <div
      class="portlet-body mt-4"
      *ngIf="
        activatedRoute == adminOrganizationRoute &&
        organzationmemberForm.controls['organizationName'].value
      "
    >
      <div class="panel-group">
        <div class="accordion">
          <div class="panel panel-default">
            <ngb-accordion [closeOthers]="true" activeIds="" class="defaultClass">
              <ngb-panel
                id="panel1"
                cardClass="open"
                (shown)="isPanelOpen = true"
                (hidden)="isPanelOpen = false"
              >
                <ng-template ngbPanelTitle>
                  <div class="panel-heading">
                    <label class="panel-title">
                      <a
                        class="accordion-toggle accordion-toggle-styled"
                        data-toggle="collapse"
                        aria-expanded="false"
                      >
                        <span class="accordion-text"
                          >{{
                            isLoading
                              ? 'Fetching user data'
                              : isPanelOpen
                              ? 'Hide user details'
                              : 'Click to see user details'
                          }}
                          <span *ngIf="isLoading" class="loading-dots"></span>
                        </span>
                      </a>
                    </label>
                  </div>
                </ng-template>
                <ng-template ngbPanelContent>
                  <div>
                    <piqet-angular-user-details
                      [data]="userInformation"
                      [isShowEditButton]="false"
                      [userInfoFromOrgMemberShip]="true"
                    ></piqet-angular-user-details>
                  </div>
                </ng-template>
              </ngb-panel>
            </ngb-accordion>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer" [ngClass]="isHideField ? '' : 'pt-3'">
    <button type="button " class="btn btn-light cancelBtn" (click)="onClose()">Cancel</button>
    <button type="button " class="modelBtn purpleBtnHoverEffect" (click)="onSave()">Save</button>
  </div>
</div>
